module.exports = __webpack_public_path__ + "media/images/search-a2e90bf116af8880b1603c832dffe44d.svg";